/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Options_Watermark_Last_UpdatedInputs */



/**
* | output |
* | --- |
* | "Last updated: {date}" |
*
* @param {Options_Watermark_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_last_updated = /** @type {((inputs: Options_Watermark_Last_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Last_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Dernière mise à jour : ${i?.date}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zuletzt aktualisiert: ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ultimo aggiornamento: ${i?.date}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Последнее обновление: ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Última actualización: ${i?.date}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`上次更新：${i?.date}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`最終更新: ${i?.date}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अंतिम अपडेट: ${i?.date}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Última atualização: ${i?.date}`)
	return /** @type {LocalizedString} */ (`Last updated: ${i?.date}`)
});